module.exports = __webpack_public_path__ + "img/plus.1116d06a.svg";